import { computed } from '@vue/composition-api'
import {useWindowSize} from "@vueuse/core";
export default function useRootSetting() {
  const getIsMobile = computed(() => {
    const {width} = useWindowSize();
    return width.value <= 992;
  });
  return {
    getIsMobile
  }
}
